module.exports = __webpack_public_path__ + "static/sanda-e67e09871a04ff37eca5644859198721.png";